import { render, staticRenderFns } from "./EnableActionsForm.vue?vue&type=template&id=6ab6d61c&scoped=true&"
import script from "./EnableActionsForm.vue?vue&type=script&lang=js&"
export * from "./EnableActionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab6d61c",
  null
  
)

export default component.exports